import React from "react";
import contactBanner from "../../assets/images/contact/contact-banner.png";
import { useNavigate } from "react-router-dom";
import { MdOutlineMail } from "react-icons/md";
import { FiPhone } from "react-icons/fi";
import { IoMdTime } from "react-icons/io";
import { CiLocationOn } from "react-icons/ci";
import { FaWhatsapp } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { AiOutlineFacebook } from "react-icons/ai";
import { CiLinkedin } from "react-icons/ci";
import { Mail } from "../../components/Mailbox";
import { useFormik } from "formik";
import { object, string } from "yup";
import { ToastContainer, toast } from "react-toastify";
import { axiosInstance } from "../../axiosInstance";

let ContactSchema = object({
  full_nmae: string().required("Name is Required"),
  number: string()
    .matches(/^\d{10}$/, "Phone Number must be 10 digits")
    .required("Phone number is Required"),
  email: string()
    .email("Invalid email address (must include '@')")
    .required("Email is required"),
});

export function Contact() {
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      full_nmae: "",
      number: "",
      email: "",
      message: "",
    },
    validationSchema: ContactSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const formattedValues = {
          ...values,
        };

        const { data } = await axiosInstance.post(
          "/insertForm",
          formattedValues
        );

        if (data.status === 200) {
          toast.success(data.message || "Successfully Submitted!");
          resetForm();
        } else {
          toast.error("Something went wrong, please try again!");
        }
      } catch (error) {
        console.error("Submission failed:", error);
        toast.error("Submission failed! Please try again.");
      }
    },
  });
  const handleSecureSubmit = (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    if (token) {
      formik.handleSubmit();
    } else {
      navigate("/login");
    }
  };

  return (
    <>
      {/* <ToastContainer /> Mail component toast will reflect here*/}
      <div className="HomeMainContainer container">
        <div className="contactBanner">
          {/* <img src={contactBanner} /> */}
          <div>
            <div className="contact-bannerTitle">Contact Us</div>
            <div className="contact-bannerDesc">
              We'd love to hear from you! Whether you have questions about our
              products, need styling advice, or want to share your feedback, our
              team is here to help
            </div>
          </div>
        </div>
        {/* contact content */}
        <div className="contact-subContainer">
          <div className="contact-left">
            <div>
              <div className="contact-left-title">Get in Touch</div>
              <div className="contact-left-desc">
                Reach out to our friendly support team for assistance with
                orders, returns, or any other inquiries.
              </div>
              <div className="contact-left-desc">
                <span>
                  <MdOutlineMail />
                </span>
                example@gmail.com
              </div>
              <div className="contact-left-desc">
                <span>
                  <FiPhone />
                </span>
                +91 9876543210
              </div>
            </div>
            <div>
              <div className="contact-left-title">Visit Us</div>
              <div className="contact-left-desc">
                Come see us in person at our store location:
              </div>
              <div className="contact-left-desc">
                <span>
                  <CiLocationOn />
                </span>
                Store address
              </div>
              <div className="contact-left-desc">
                <span>
                  <IoMdTime />
                </span>
                Mon-Sat, 10 AM - 8 PM
              </div>
            </div>
            <div>
              <div className="contact-left-title">Connect on Social Media</div>
              <div className="contact-left-desc">
                Stay updated with the latest trends and promotions by following
                us on:
              </div>
              <div className="contact-icons">
                <span>
                  <FaWhatsapp />
                </span>
                <span>
                  <FaInstagram />
                </span>
                <span>
                  <AiOutlineFacebook />
                </span>
                <span>
                  <CiLinkedin />
                </span>
              </div>
            </div>
          </div>

          <div className="contact-right">
            <div className="contact-right-title">
              Fill out the form below, and our team will get back to you
              shortly.
            </div>
            <div>
              <form onSubmit={handleSecureSubmit}>
                <div className="contact-field">
                  <label for="full_nmae">Full Name</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter your First Name"
                      id="full_nmae"
                      value={formik.values.full_nmae}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.full_nmae && formik.errors.full_nmae && (
                      <div className="formError">{formik.errors.full_nmae}</div>
                    )}
                  </div>
                </div>
                <div className="contact-field">
                  <label for="number">Phone Number</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter your phone number"
                      id="number"
                      onChange={formik.handleChange}
                      value={formik.values.number}
                    />
                    {formik.touched.number && formik.errors.number && (
                      <div className="formError">{formik.errors.number}</div>
                    )}
                  </div>
                </div>
                <div className="contact-field">
                  <label for="email">Email Address</label>
                  <div>
                    <input
                      type="email"
                      placeholder="Enter your email address"
                      id="email"
                      onChange={formik.handleChange}
                      value={formik.values.email}
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className="formError">{formik.errors.email}</div>
                    )}
                  </div>
                </div>
                <div className="contact-field">
                  <label for="message">Your Message</label>
                  <div>
                    <textarea
                      placeholder="Type here"
                      rows={3}
                      name="message"
                      value={formik.values.message}
                      onChange={formik.handleChange}
                    ></textarea>
                  </div>
                </div>
                <div className="btnContactSubmit">
                  <button type="submit">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div>
          <Mail />
        </div>
      </div>
    </>
  );
}
